export default __webpack_public_path__ + "static/media/2500_en.0fd194f1.ods";